// extracted by mini-css-extract-plugin
export default {"removeWatermarkingModalIcon":"Hghsep_vdw4wS4Fhlvj3"};